import { CircularProgressbar as ProgressCircle, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

ProgressCircle.buildStyles = buildStyles;

export default ProgressCircle;
